import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100% - 64px);
  display: flex;
  gap: 12px;
  flex-direction: column;
  justify-content: space-between;
`;
